import React, {Component} from "react";
import aboutImg1 from "../img/about1.png";
import aboutImg2 from "../img/about2.png";
import aboutImg3 from "../img/about3.jpg";
import aboutImg4 from "../img/about4.jpg";
import aboutImg5 from "../img/about5.jpg";
import aboutImg6 from "../img/about6.jpg";

class AboutPage extends Component {
    render() {
        return (
            <div className="about">
                <div className="container">
                    <h2 className="display-4">What is "Danmaku"?</h2>
                    <p>Danmaku, also known as "bullet curtain", is a kind of comment function only exist in certain
                        video
                        stream sites. Unlike the traditional video sharing sites whose comment box is placed below the
                        video, and comments are ranged in time order, video sharing sites with Danmaku function not only
                        have the traditional comment box, but also enable audience to "shoot" their comments immediately
                        onto the video they're watching. The comments sync with the video timeline, and slide over the
                        video
                        (also possible to be displayed as subtitles to the top and bottom of the screen by the command
                        function), creating a sense of shared watching experience.</p>
                    <p>The below video clip of animation Card Fight!'s opening song "Vanguard" is an example of how
                        danmaku
                        works. These synchronized comments of lyrics give viewers a sense that all the viewers are
                        singing
                        together.</p>
                    <iframe width="960px" height="540px" className="mx-auto d-block"
                            src="https://www.youtube.com/embed/DZi_n-agDX0" frameBorder="0"
                            allowFullScreen></iframe>
                    <h2 className="display-4">The originator of Danmaku</h2>
                    <p>The originator of Danmaku was Nico Nico, a Japanese video sharing site founded in 2006. Most
                        videos
                        are generated and uploaded by the netizens. Its comment function enables viewers to write
                        comments
                        on playback screen for the playing video. Comments will be shot onto the screen, and when the
                        video
                        is reproduced thereafter, previous comments will also be displayed in accordance with the time
                        axis.
                        Therefore, the comments go beyond the real-time, and the previous comments and later comments
                        coexist together.</p>
                    <p>In fact, the time when a comment was posted and the time when that comment was read by another
                        viewer
                        is different (asynchronous), but when the video is reproduced, the comments will be posted at
                        the
                        same time, giving viewers an illusion as if they were synchronous. </p>
                    <p>By introducing the concept of Danmaku, Nico Nico has succeeded in acquiring the "unity among
                        users".
                        Viewers can not only share their comments, but also decorate the videos with comments, by making
                        full use of the "command function". Command function enables viewers to produce comments with
                        more
                        complicated forms. Viewers can change the color, size, appearing location and existing time
                        length
                        of a comment. </p>
                    <p>But there're also crazy times when the screens are occupied with comments and viewers can't see
                        anything. In that case, or whenver you feel disturbed, simply check "Hide Comments" option,
                        Danmaku
                        will disappear, adn videos will just become ordinary videos.</p>
                    <p>Below is a music video decorated with advanced Danmaku. These comments serve as subtitles for the
                        lyrics, but in a more creative way. They spin and swirl according to the meaning of lyrics. When
                        the
                        lyrics come to "My split heart", the comments split as well. In such case, the advance Danmaku
                        syncs
                        with the lyrics, hence enhances the expirence.</p>
                    <iframe width="960px" height="540px" className="mx-auto d-block"
                            src="https://www.youtube.com/embed/ckpOWL2ogcU" frameBorder="0"
                            allowFullScreen></iframe>
                    <h2 className="display-4">The followers</h2>
                    <p>With the rise of Nico Nico, Chinese start-ups also began imitating this unique feature of
                        Danmaku.
                        Around 2009, two Danmaku video sharing sites AcFun, and Bilibili were founded. Their target
                        audience
                        are people fond of "ACG"(acronym for Animation, Comic and Game, especially Japanese ACG). The
                        rise
                        of Chinese Danmaku video sharing sites provided the hotbed for subculture in ACG and spoof
                        videos.
                        It's also worth mentioning that the spoof videos made from Chinese netizens are filled with
                        Chinese-style humor, some classic Danmaku for the videos went viral and even became Internet
                        slangs.</p>
                    <p>Below is a spoof video of a famous Chinese dubber, and the video is filled with decorative
                        subtitles.
                        It's also interesting to see the check ins in the beginning of the video.</p>
                    <iframe className="mx-auto d-block" src="https://www.youtube.com/embed/R_LFLdyUfi0?ecver=2" width="960px" height="540px" frameborder="0" allowfullscreen></iframe>
                    <h2 className="display-4">Regional differences</h2>
                    <p>It's interesting to notice that Danmaku has been extremely successful in Japan and China.
                        However, it
                        has never been popular in US or European countries, despite the fact that there're also quite
                        many
                        ACG fans in these countries.</p>
                    <p>Nico Nico has tried to promote an English version for the oversea market. (If you access Nico
                        Nico
                        with foreign IP, you'll be automatically directed to the English site, unless you reset the
                        website
                        setting to Japanese version.)</p>
                    <p>So it's surprising to see how the Danmaku is different from the English version to the Japanese
                        version, even for a same video.</p>
                    <p>Below is a music video for the character Alice in Touhou Project. And the only word I can use to
                        describe the English Danmaku is, "Dull."</p>
                    <p>However, if you change the language environment for Danmaku into Japanese for this video clip,
                        the
                        outcome will be totally different.</p>
                    <p>The Japanese Danmaku is filled with sentences ending in "~yo Alice", such as"It's hard to get the
                        credits yo Alice","You're so cute yo Alice", "This year has past yo Alice". The unity of
                        sentences
                        give viewers a sense that they're tied together, and they're not just posting comments, they are
                        posting their daily emotions, as if they are devout believers of Alice.</p>
                    <p>The reason why English Danmaku hasn't been popular may be account to the weak basis of ACG
                        culture.
                        Another possible reason is because of the uniqueness of languages. Japanese and Chinese can be
                        expressed within few characters, while English usually needs long sentences to convey the
                        concise
                        meaning, which make it difficult to be presented to viewers within few seconds. On the other
                        hand,
                        we are already seeing similar trends in twitch chats. There's potentially huge growth
                        opportunity in
                        the west for danmaku, too. </p>
                    <img className="img-fluid mx-auto d-block aboutImg" src={aboutImg1} alt="about1"></img>
                    <h2 className="display-4">A Peep into Danmaku</h2>
                    <p>As Danmaku sites are mostly filled with animations and spoof videos, "entertainment first, avoid
                        being too serious" is the "core value" of Danmaku sites.</p>
                    <p>When posting Danmaku, it's hard for viewers to post anything expressing "historical mission" or
                        "concern for the country". What Danmaku does is to bring a group of people who share a common
                        value
                        together. It's a place where they can focus on the video itself and put aside the politic or
                        historical problems. Danmaku is so important that sometimes viewers will refuse to watch a new
                        video
                        because "the Danmaku is not thick enough". They would rather wait until more Danmaku is created.
                        Without Danmaku, sometimes the viewers would even feel relentless.</p>
                    <p>The unique characteristics and cohesiveness of Danmaku helps the formation of a subculture
                        community.
                        The Danmaku content is generally more optimistic and self-deprecating, showing a great sense of
                        humor.</p>
                    <p>The language used in Danmaku is also unique, and has even developed a unique cant system.</p>
                    <h3>A Sample of Danmaku Cants</h3>
                    <blockquote className="blockquote">
                        <dl>
                            <dt><strong>"No jump":</strong></dt>
                            <dd>I'm not gonna jump the opening, because it's fantastic.</dd>
                            <dt><strong>"Airborne":</strong></dt>
                            <dd>Forward to the crucial part and skip the irrelevant part.</dd>
                            <dt><strong>"I'm typing with my two hands to prove my innocence.":</strong></dt>
                            <dd>Indicating the horny scene is hard for people to hold themselves.</dd>
                            <dt><strong>"AV definition":</strong></dt>
                            <dd>Low-definition as the porn downloaded from the Internet.</dd>
                            <dt><strong>"Evacuation! Evacuation! This is not a fire drill!":</strong></dt>
                            <dd>Next scene will be really shocking/frightening, get prepared.</dd>
                            <dt><strong>"High-energy alarm":</strong></dt>
                            <dd>Next scene will be really shocking/frightening, get prepared.</dd>
                            <dt><strong>"Nuclear launch detected":</strong></dt>
                            <dd>Next scene will be really shocking/frightening, get prepared.</dd>
                            <dt><strong>"UP lord":</strong></dt>
                            <dd>Uploader of video</dd>
                            <dt><strong>"UP lord I wanna carry your baby":</strong></dt>
                            <dd>Highly praise for the uploader, indicating the video his made is really overwhelming.
                            </dd>
                            <dt><strong>"My Mom asked me why I watch the video when kneeling.":</strong></dt>
                            <dd>Highly praise for the uploader.</dd>
                            <dt><strong>"UP lord please take my kneel":</strong></dt>
                            <dd>Highly praise for the uploader.</dd>
                            <dt><strong>"UP lord have a nice meal.":</strong></dt>
                            <dd>The uploader has touched some political-sensitive topics.</dd>
                        </dl>
                    </blockquote>
                    <h2 className="display-4">Pros</h2>
                    <blockquote className="blockquote">
                        <p>"I enjoy good company, even more than the show."</p>
                    </blockquote>
                    <p>This might explain why so many people are so addicted to video sharing sites with Danmaku
                        function.
                    </p>
                    <p>We all have times when watching TV at home alone, hoping there're someone we can talk to, to
                        express
                        our feeling about the latest episode.
                    </p>
                    <p>And Danmaku solves our innate demand for socializing. With everyone watching the same video,
                        seeing
                        others dissing on the content and expressing their views, such participation and interaction,
                        can
                        never be compared with the experience of quietly watching a video alone. Even a dull episode can
                        become hilarious with the dissing Danmaku. Not to mention other irreplaceable functions of
                        Danmaku.
                    </p>
                    <p>Danmaku can be roughly divided into three categories: functional Danmaku, interactive Danmaku and
                        decorative Danmaku.
                    </p>
                    <h3>1.Functional Danmaku</h3>
                    <p>Functional Danmaku include subtitles, annotations, supplementary resources, alerts and so on.
                    </p>
                    <p>Subtitles: As video sharing sites, tons of foreign episodes are uploaded to the sites everyday.
                        Sometimes subtitles can't be embedded into the video in time, then "translators at wild" will
                        voluntarily do the translation, and post their comments in the forms of subtitles.
                    </p>
                    <p>Annotations: Some videos such as "Jon Stewart Show" require background knowledge for American
                        culture, so viewers who are familiar with the slangs will shoot their comments on the videos,
                        explaining the gag for viewers.
                    </p>
                    <p>Supplementary resources: It can appear either in a drama video, trying to explain what a metaphor
                        means, or can be in a video clip of billboard TOP 50 songs, telling viewer the playing song's
                        historical ranks in the past few weeks.
                    </p>
                    <img className="img-fluid mx-auto d-block aboutImg" src={aboutImg2} alt="about2"></img>
                    <blockquote className="blockquote">
                        <small>The yellow words in the picture above serve as a supplementary resource, telling people
                            the
                            historical ranks of "The Man" in the past few weeks.
                        </small>
                    </blockquote>
                    <h3>2. Interactive Danmaku</h3>
                    <p>Interactive Danmaku include dissing the content, post mondegreen on purpose, check in, resonation
                        and
                        so on. The biggest feature of interactive Danmaku is the "sense of participation." In many
                        cases,
                        viewing others' comments are even more interesting than the video itself.
                    </p>
                    <p>Dissing the content: It's just like what people do on traditional video sharing sites. However,
                        as
                        the comments goes with the plot, you can quickly and accurately express the emotion, which is
                        more
                        direct and infectious.
                    </p>
                    <p>Mondegreen: It's especially common when it comes to foreign songs or emotional lines in a drama.
                        People are easier to be immersed in the scenario with the instant subtitles.
                    </p>
                    <p>Check in: Viewers like posting Danmaku at the beginning of a hot video in the form of
                        "Year/Month/Day
                        check in" in remembrance of their viewing. You can also judge whether a video is popular or not
                        by
                        the amount of check ins at the beginning.
                    </p>
                    <p>Resonation: Resonation often occur in music videos or the opening of an animation. Viewers post
                        lyrics onto the screen as the song goes as if they're sing together.
                    </p>
                    <img className="img-fluid mx-auto d-block aboutImg" src={aboutImg3} alt="about3"></img>
                    <blockquote className="blockquote">
                        <small>Resonation of music video "Some like it hot", covered with the lyrics "Hey Hey Hey Hey
                            Hey".
                        </small>
                    </blockquote>
                    <h3>3. Decorative Danmaku</h3>
                    <p>Some Danmaku are meaningless. They're just posted to be part of the video for fun.
                    </p>
                    <p>There also exist a group of people called "craftsmen", who are experts in creating advanced forms
                        of
                        Danmaku. They're especially talented at using color blocks to build certain images overlapping
                        the
                        video, or create some movements with color blocks and symbols.
                    </p>
                    <iframe width="960px" height="540px" className="mx-auto d-block"
                            src="https://player.youku.com/embed/XMjEyMTY1MDQw" frameBorder="0"
                            allowFullScreen></iframe>
                    <blockquote className="blockquote">
                        <small>Resonation of music video "Some like it hot", covered with the lyrics "Hey Hey Hey Hey
                            Hey".
                        </small>
                    </blockquote>
                    <h2 className="display-4">Cons</h2>
                    <blockquote className="blockquote">
                        <p>"It's forcing me not to turn on the Danmaku option when first viewing an episode."</p>
                    </blockquote>
                    <p>With the rise of Danmaku sites, more and more people have become familiar with this new trend and
                        have joined the Danmaku army. It is for sure that the metabolism of Danmaku sites will lead to
                        the changes of Danmaku quality. Unfortunately, judging from the current situation, it's a
                        decrease in quality.
                    </p>
                    <p>Younger generation tend to be less legitimate and like posting meaningless Internet slangs such
                        as LOLLLLLL, hhhh, 23333 (all represent laughters) to fill the screens. There're less thoughtful
                        comments.
                    </p>
                    <p>And this is not the most annoying thing.
                    </p>
                    <p>There's nothing more annoying than the spoilers.
                    </p>
                    <p>When you see the colorful text deliberately shot to the center of the screen, surrounded with
                        arrows pointing to it, saying "The heroin will be dead at 23 mins";
                    </p>
                    <p>When you just saw a new character, thinking "This girl is cute." and immediately a Danmaku
                        appears, "This girl will be dead at next episode";
                    </p>
                    <p>When you watch "The Friends" for the first time, and seeing the Danmaku at the first season "I
                        can believe that XX and OO got married at last, I really can not see it from the first season."
                    </p>
                    <p>Not to say those quarrels over characters overlapping the screen, it affects the viewing
                        experience badly. Although there is functions like blocking certain users or blocking certain
                        key words. It's still hard to prevent all the discomforts.
                    </p>
                    <p>As a result, some people just choose to switch off the Danmaku function when they watch drama
                        series, and only leave it on when watching news or spoofs.
                    </p>
                    <img className="img-fluid mx-auto d-block aboutImg" src={aboutImg4} alt="about4"></img>
                    <blockquote className="blockquote">
                        <small>Pic1: Thick Danmaku which block the screen
                        </small>
                    </blockquote>
                    <img className="img-fluid mx-auto d-block aboutImg" src={aboutImg5} alt="about5"></img>
                    <blockquote className="blockquote">
                        <small>Pic2: Meaningless "Yooooooooooo"
                        </small>
                    </blockquote>
                    <img className="img-fluid mx-auto d-block aboutImg" src={aboutImg6} alt="about6"></img>
                    <blockquote className="blockquote">
                        <small>Pic3: Spoiler of pointing out the murderer
                        </small>
                    </blockquote>
                </div>
            </div>
        );
    }
}
export default AboutPage;


// WEBPACK FOOTER //
// ./src/componentsBody/AboutPage.js